import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstanceIncidentsController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstanceIncidentsController.php:22
* @route '/admin-panel/instance-incidents'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin-panel/instance-incidents',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstanceIncidentsController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstanceIncidentsController.php:22
* @route '/admin-panel/instance-incidents'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstanceIncidentsController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstanceIncidentsController.php:22
* @route '/admin-panel/instance-incidents'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstanceIncidentsController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstanceIncidentsController.php:22
* @route '/admin-panel/instance-incidents'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstanceIncidentsController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstanceIncidentsController.php:22
* @route '/admin-panel/instance-incidents'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstanceIncidentsController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstanceIncidentsController.php:22
* @route '/admin-panel/instance-incidents'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\WhatsappInstanceIncidentsController::index
* @see app/Http/Controllers/AdminPanel/WhatsappInstanceIncidentsController.php:22
* @route '/admin-panel/instance-incidents'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const instanceIncidents = {
    index: Object.assign(index, index),
}

export default instanceIncidents